import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { InspectionPointService } from '../../shared/services/index';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './edit-json.component.html',
    standalone: false
})
export class PointEditJsonPageComponent extends BaseModalPageComponent implements OnInit {
  public point: any;
  public inspectionId: string;
  public pointId: string;
  public processing = false;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pointService: InspectionPointService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      this.initData();
    });
  }

  initData(): void {
    this.pointService.getPointEntity(this.inspectionId, this.pointId).subscribe((data) => {
      this.point = data;
    });
  }

  savePoint(point: any): void {
    this.processing = true;
    this.pointService.updatePointEntity(this.inspectionId, this.pointId, point).subscribe((res) => {
      this.goToBack();
    });
  }

  cancel(): void {
    this.goToBack();
  }
}
